import { render, staticRenderFns } from "./definition-de-bouche-a-oreille.vue?vue&type=template&id=c622998c&"
import script from "./definition-de-bouche-a-oreille.vue?vue&type=script&lang=js&"
export * from "./definition-de-bouche-a-oreille.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports